<div class="card custom-card" *ngIf="activePrograms.length">

    <!-- Header -->
    <div class="card-header d-flex justify-content-between align-items-center">
        <h2 class="mb-0">Active Programs</h2>
        <a class="btn btn-sm btn-light-primary" [routerLink]="['/call-for-applications']">
            View all
        </a>
    </div>

    <div class="card-body program-container">
        <div class="state-center" *ngIf="loading">
            <span class="spinner-border spinner-border-sm"></span>
        </div>

        <div class="state-center text-danger" *ngIf="!loading && errorMessage">
            {{ errorMessage }}
        </div>
        <div class="state-center text-muted" *ngIf="!loading && !errorMessage && !activePrograms.length">
            No active programs found
        </div>

        <div class="program-grid" *ngIf="!loading && activePrograms.length">

            <div class="program-card" *ngFor="let program of activePrograms; trackBy: trackByProgramUuid"
                (click)="openProgram(program)">
                <div class="program-image">
                    <div class="corner-ribbon" *ngIf="program.isProgramChallengeType=='business_challenge'">Challenge
                    </div>
                    <div class="promoted-badge" *ngIf="program.isPromoted && program.promotedFromName" [title]="getProvenanceBadgeLabel(program)">{{ getProvenanceBadgeLabel(program) }}
                    </div>
                    <img *ngIf="program?.programLogo" [src]="program.programLogo | imagekitUrlAppender" />
                    <!-- <img *ngIf="!program?.programLogo"
                        [src]=" 'https://ik.imagekit.io/3buq5bm7v/sncnt/global-assets/images/no-logo-uploaded.png?tr=w-200,h-200,cm-pad_resize'"
                        alt="news image" /> -->
                          <div class="d-flex justify-content-center align-items-center w-100 h-100" style="font-size: 5rem;"
                        *ngIf="!program?.programLogo">
                        <i class="fa fa-hand-holding-usd text-muted"></i>
                    </div>


                    <div class="program-overlay" ngbTooltip="{{ program.programTitle }}">
                        <h4 class="program-title">
                            {{ program.programTitle |titlecase }}
                        </h4>
                    </div>

                </div>

                <div class="program-content">
                    <p class="program-desc" *ngIf="program.shortDescription">
                        {{ program.shortDescription }}
                    </p>
                    <p class="text-gray-600 fs-9 m-0 p-0" *ngIf="program.applicationClosedDate">
                        Deadline: <ng-container>{{program.applicationClosedDate |
                            date:'mediumDate'}}</ng-container>
                    </p>
                </div>

            </div>

        </div>

    </div>
</div>